import * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BulkEditProjectManagerMutationVariables = Types.Exact<{
  userPrincipalName: Types.Scalars['String'];
  projectNumbers: Array<Types.Scalars['Int']> | Types.Scalars['Int'];
}>;


export type BulkEditProjectManagerMutation = { __typename?: 'MutationModel', projects?: { __typename?: 'ProjectsMutationModel', editProjectManager?: { __typename?: 'ValidationResponse', errors?: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string } | null> | null } | null } | null };


export const BulkEditProjectManagerDocument = gql`
    mutation BulkEditProjectManager($userPrincipalName: String!, $projectNumbers: [Int!]!) {
  projects {
    editProjectManager(
      userPrincipalName: $userPrincipalName
      projectNumbers: $projectNumbers
    ) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type BulkEditProjectManagerMutationFn = Apollo.MutationFunction<BulkEditProjectManagerMutation, BulkEditProjectManagerMutationVariables>;

/**
 * __useBulkEditProjectManagerMutation__
 *
 * To run a mutation, you first call `useBulkEditProjectManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEditProjectManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEditProjectManagerMutation, { data, loading, error }] = useBulkEditProjectManagerMutation({
 *   variables: {
 *      userPrincipalName: // value for 'userPrincipalName'
 *      projectNumbers: // value for 'projectNumbers'
 *   },
 * });
 */
export function useBulkEditProjectManagerMutation(baseOptions?: Apollo.MutationHookOptions<BulkEditProjectManagerMutation, BulkEditProjectManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkEditProjectManagerMutation, BulkEditProjectManagerMutationVariables>(BulkEditProjectManagerDocument, options);
      }
export type BulkEditProjectManagerMutationHookResult = ReturnType<typeof useBulkEditProjectManagerMutation>;
export type BulkEditProjectManagerMutationResult = Apollo.MutationResult<BulkEditProjectManagerMutation>;
export type BulkEditProjectManagerMutationOptions = Apollo.BaseMutationOptions<BulkEditProjectManagerMutation, BulkEditProjectManagerMutationVariables>;